import { inject, Injectable } from '@angular/core';
import { AppRoutes } from '@core/routes/route.paths';
import { UserService } from '@core/services/user/user.service';
import { SubMenu } from '@shared/model/menu-item.type';

@Injectable({
  providedIn: 'root',
})
export class MenuSsoService {
  private readonly userService = inject(UserService);

  getMenu(): SubMenu {
    const isSuperUser = this.userService.isSuperUser();

    const items = [
      { label: 'sub-menu-sso.creation', routerLink: AppRoutes.Sso.creation },
      { label: 'sub-menu-sso.management', routerLink: AppRoutes.Sso.management },
    ];

    if (isSuperUser) {
      items.unshift({ label: 'sub-menu-sso.admin', routerLink: AppRoutes.Sso.root });
    }

    return {
      root: { label: 'menu.sso', routerLink: !isSuperUser ? AppRoutes.Sso.management : AppRoutes.Sso.root },
      items,
    };
  }
}
